// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  env: 'dev',
  productName: 'Codaclean Dev',
  appId: 'Codaclean-Dev',
  api_url: 'https://api.dev.codaclean.io/',
  cognito: {
    userPoolRegion: 'eu-west-1',
    userPoolId: 'eu-west-1_KbKzgjAHc',
    userPoolClientId: '3uo6cbgf2a26dhfoj5aslgv83e',
    userPoolUrl: 'https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_KbKzgjAHc',
    authenticationFlow: 'USER_SRP_AUTH',
  },  
  horus: {
    enabled: true,
    authorizeUrl: 'https://my-horus.com/fr/api/oauth2/authorize',
    clientId: 'ck_7598xo97svvjvxj',
    scope: ''
  },
  syncAgentCalendlyBaseUrl: 'https://calendly.com/codaclean-support/install-syncagent',
  syncAgentSetupUrl: 'https://link.codaclean.io/syncagent',
  syncAgentGuideBaseUrl: 'https://link.codaclean.io/faq-syncagent',
  codbIncomingEmail: 'codb-dev@incoming.codaclean.io',
  enableCodaLightMandateRequest: true,
  enableChatbot: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
